import React from 'react';
import { PagoEncuestaResultComponent } from '../../Components/Encuestas/PagoEncuestaResultComponent';

// Ver PagoEncuestaOkPage.js: mismo motivo para no llevar el chrome general.
export const PagoEncuestaKoPage = () => (
  <PagoEncuestaResultComponent mode="ko" />
);
